import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import course3 from '../assets/1.jpg';
import { useAuth } from './authcontext';
import './header.css';

const Header = () => {
  const [username, setUsername] = useState("");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { logout, primaryRoleLabel, user } = useAuth();

  useEffect(() => {
    try {
      if (user) {
        // Use firstname + lastname if available
        const displayName =
          user.firstname && user.lastname
            ? `${user.firstname} ${user.lastname}`
            : user.firstname || user.lastname || user.email || user.name || "User";

        setUsername(displayName);
        setUserEmail(user.email || '');
      }
    } catch (err) {
      console.error("Error reading user from localStorage:", err);
    }
  }, [user]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowUserMenu(false);
      }
    };

    if (showUserMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserMenu]);

  const handleLogout = () => {
    logout();
    localStorage.removeItem('staffId');
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        <div className="admin-badge">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"/>
          </svg>
          <span>{primaryRoleLabel}</span>
        </div>
      </div>
      
      <div className="header-center">
        <h2 className="header-title">EnRiCH DLP Admin Dashboard</h2>
      </div>
      
      <div className="header-right">
        <div className="user-profile-container" ref={menuRef}>
          <button 
            className="user-profile-button"
            onClick={() => setShowUserMenu(!showUserMenu)}
            aria-label="User menu"
          >
            <div className="welcome-message">
              <div className="welcome-text">
                <span className="welcome-label">Welcome,</span>
                <strong className="username">{username || "Loading..."}</strong>
              </div>
              <div className="avatar-wrapper">
                <img src={course3} alt="User Avatar" className="avatar" />
                <div className="avatar-status"></div>
              </div>
              <svg 
                className={`dropdown-arrow ${showUserMenu ? 'open' : ''}`}
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2"
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
          </button>

          {showUserMenu && (
            <div className="user-menu">
              <div className="user-menu-header">
                <div className="user-menu-avatar">
                  <img src={course3} alt="User" />
                </div>
                <div className="user-menu-info">
                  <div className="user-menu-name">{username}</div>
                  {userEmail && <div className="user-menu-email">{userEmail}</div>}
                </div>
              </div>
              <div className="user-menu-divider"></div>
              <div className="user-menu-items">
                <button 
                  className="user-menu-item"
                  onClick={() => {
                    navigate('/settings');
                    setShowUserMenu(false);
                  }}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                  </svg>
                  <span>Settings</span>
                </button>
                <button 
                  className="user-menu-item logout-item"
                  onClick={handleLogout}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
